import * as React from 'react';
import cls from 'classnames';

import { Formik, FormikProps, Field, FormikHelpers as FormikActions, FormikErrors } from 'formik';
import TextInput from '../../input-text';

const styles = require('../CCPA.scss');

export interface FormData {
    email: string;
    firstName: string;
    lastName: string;
}

interface Props {
    initialValues?: Partial<FormData>;
    handleOnCancelClick: () => void;
    handleOnSubmit: (data: FormData, formikActions?: FormikActions<Partial<FormData>>) => void;
}

export default class CCPADoNotSellForm extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div className={styles.contentContainer}>
                <div className={styles.mainText}>Please enter your information below to help us find it in our systems</div>
                <Formik
                    initialValues={
                        this.props.initialValues || {
                            email: '',
                            firstName: '',
                            lastName: '',
                        }
                    }
                    onSubmit={this.props.handleOnSubmit}
                >
                    {(props: FormikProps<FormData>) => {
                        return (
                            <form onSubmit={props.handleSubmit} className={styles.mainForm}>
                                <div>
                                    <Field name='email' type='email' label='Email' component={TextInput} required={true} />
                                    <Field name='firstName' type='text' label='First Name' component={TextInput} required={true} />
                                    <Field name='lastName' type='text' label='Last Name' component={TextInput} required={true} />
                                </div>
                                <div className={styles.ctaContainer}>
                                    {props.status && <div className={styles.formLevelError}>{props.status}</div>}
                                    <button className='nx-button' onClick={this.props.handleOnCancelClick} type='button'>
                                        Cancel
                                    </button>
                                    <button
                                        type='submit'
                                        className='nx-button nx-button--primary'
                                        disabled={
                                            !props.values.email || !props.values.firstName || !props.values.lastName || props.isSubmitting
                                        }
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </div>
        );
    }
}
